import { ChangeEvent, FormEvent, useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { ApiError } from "components";
import { RoleForm } from "./components/RoleFoem";
import { createRole } from "modules/auth/role/store/action";
import { CreateRoleInput, RoleError } from "modules/auth/role/store/actionType";
type OwnProps = {
  closeModal: React.Dispatch<React.SetStateAction<boolean>>;
};
type DispatchProps = ReturnType<typeof mapDispatchToProps>
type Props = DispatchProps & OwnProps;
const HandleCreateRole: React.FC<Props> = ({
  closeModal,
  onCreateRole,
}) => {
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState<CreateRoleInput>({
    name: "",
    description: "",
  });
  const [error, setError] = useState<RoleError>({});
  const [apiError, setApiError] = useState(null);
  const roleState = useSelector(
    (state: any) => state.roles?.genericRoleState,
  );
  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setError((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const handleSave = async (e: FormEvent) => {
    e.preventDefault();

    if (formData.name.trim() === "") {
      setError((prevErrors) => ({
        ...prevErrors,

        name: "Role Name is required",
      }));
    }

    if (formData.description.trim() === "") {
      setError((prevErrors) => ({
        ...prevErrors,

        description: "Role Description is required",
      }));
    }
    if (
      formData.name.trim() !== "" &&
      formData.description.trim() !== ""
    ) {
      setSubmitted(true)
      setLoading(true);
      try {
        await onCreateRole(formData);
      } catch (err) {
        console.error("Failed to create package:", err);
      } finally {
        setLoading(false);
         closeModal(false);
      }
    }
  };
    useEffect(() => {
  if (submitted) {
    if (roleState.error) {
      setApiError(roleState.error);
    } else if (roleState.status === "SUCCESS") { // or isCreated
      setApiError(null);
    }
  }
}, [roleState.error, roleState.status, submitted]);
  return (
    <>
      <RoleForm
        handleSubmit={handleSave}
        formData={formData}
        handleChange={handleChange}
        errors={error}
        loading={loading}
        header={"Create Roles"}
      />
      {apiError && <ApiError>{apiError}</ApiError>}
    </>
  );
};
const mapDispatchToProps = (dispatch: any) => ({
  onCreateRole: (input: CreateRoleInput) =>
    dispatch(createRole(input)),
});
export default connect(
  null,
  mapDispatchToProps
)(HandleCreateRole);
